"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _BaseGA4Analytics2 = _interopRequireDefault(require("../common/BaseGA4Analytics"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var GA4Analytics = /*#__PURE__*/function (_BaseGA4Analytics) {
  (0, _inherits2["default"])(GA4Analytics, _BaseGA4Analytics);

  var _super = _createSuper(GA4Analytics);

  function GA4Analytics() {
    (0, _classCallCheck2["default"])(this, GA4Analytics);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(GA4Analytics, [{
    key: "setup",
    value: function setup(analyticsId, secretId) {
      var newScript = document.createElement("script");
      newScript.type = "text/javascript";
      newScript.setAttribute("async", "true");
      newScript.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=" + this.analyticsId);
      document.head.appendChild(newScript);
      window.dataLayer = window.dataLayer || [];

      function gtag() {
        dataLayer.push(arguments);
      }

      window.gtag = gtag;
      this.gtag = gtag;
      this.gtag('js', new Date());
      this.gtag('config', analyticsId, {
        'send_page_view': false,
        'cookie_prefix': '_qwGa',
        'cookie_domain': 'auto',
        'cookie_update': true,
        'cookie_expires': 28 * 24 * 60 * 60,
        // 28 days, in seconds
        'cookie_flags': 'SameSite=None;Secure',
        'linker': {
          'domains': ['qwoach.com']
        }
      });
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId) {
      this.log("GA4: setUserId = ", userId);
      this.gtag('set', {
        user_id: userId
      });
    }
  }, {
    key: "setUserProps",
    value: function setUserProps(props) {
      this.log("GA4: setUserProps = ", props);
      this.gtag('set', 'user_properties', props);
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(eventName, props) {
      this.log("GA4 trackEvent: eventName = ", eventName, ", props = ", props);
      this.gtag('event', eventName, props);
    }
  }]);
  return GA4Analytics;
}(_BaseGA4Analytics2["default"]);

exports["default"] = GA4Analytics;